exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-6a686239] {\n  height: 45px;\n  color: #33c435;\n  font-size: 18px;\n  line-height: 45px;\n  text-align: center;\n  width: 80%;\n  border-radius: 4px;\n  margin: 50px auto auto;\n  border: 1px solid #33C435;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a686239","scoped":true,"hasInlineConfig":false}!./~/vux-loader/src/after-less-loader.js!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/register.vue
// module id = 271
// module chunks = 1